import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import { useParams } from "react-router-dom";
import { Box, Button, MenuItem, Select } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import TimeFrameDateSelector from "components/TimeFrameDateSelector"
import LoaderAnimation from "pages/LoaderAnimation";
import { apiGet, apiPost } from "app/Services/ApiService";
import ListIcon from "@mui/icons-material/List";
import { Utils } from "common/Utils";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import HWStatementDetail from "components/HWStatementDetail";

export default function Reports(props) {
    const { userInfo } = useContext(PrivateRoutesContext);

    const [hwStatements, setHwStatements] = useState([]);

    const [isLoadingData, setIsLoadingData] = useState(false);
    const [hasLoadedData, setHasLoadedData] = useState(false);
    const [hasLoadingError, setHasLoadingError] = useState(false);
    const [isViewEnabled, setIsViewEnabled] = useState(true);

    const [isExporting, setIsExporting] = useState(false);

    const report = useRef("");
    let { hwBenefitDate } = useParams();

    const canDownload = useMemo(() => {
      return !Utils.isBroker(userInfo);
    },[userInfo]);

    const loadHWStatements = (time, payDate, endDate) => {
        setIsViewEnabled(false);
        setIsLoadingData(true);
        setHasLoadedData(true);
        setHasLoadingError(false);
        setHwStatements([]);

        apiGet(props.getHWStatementUrl(payDate, endDate)).then((response) => {
            let tempStatements = response.data.map(d => {
                d.endDate = endDate;
                d.timePeriod = time;

                return d;
            });

            setHwStatements(tempStatements);
            setIsLoadingData(false);
            setIsViewEnabled(true);
        })
        .catch(e => {
            console.log(e);
            setHasLoadingError(true);
        });
    };

    const handleExport = () => {
        if (hwStatements.length > 0) {
            setIsExporting(true);
          let pdfHtml = Utils.hwStatementReport(report.current.outerHTML);
          const formData = new FormData();
          formData.append("htmlData", pdfHtml);
    
          console.log("Exporting");

          apiPost(props.exportUrl, formData, {
              "content-type": "multipart/form-data",
              Accept: "*/*",
              responseType: "blob",
          }).then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "hwStatement.pdf");
            document.body.appendChild(link);
            link.click();
      
            console.log("File downloading successfully");
          })
            .catch((e) => {
                
            })
            .finally(() => {
                setIsExporting(false);
            });
        }
        else {
            
        }
      }

    return (
        <Box className="container-fluid">
            <Box className="d-flex justify-content-end align-items-center mb-2">
                <TimeFrameDateSelector payPeriodsUrl={props.payPeriodsUrl}
                                    handleView={loadHWStatements}
                                    isViewEnabled={isViewEnabled}
                                    defaultValue={hwBenefitDate} />


                {canDownload ? 
                    <LoadingButton
                        variant="outlined"
                        onClick={handleExport}
                        className={ButtonStyle.CsubmitBtn}
                        disabled={hwStatements.length == 0}
                        startIcon={<ListIcon />}
                        loading={isExporting}
                        loadingPosition="start"
                    >
                        Export to PDF
                    </LoadingButton>
                : null}
            </Box>
            <Box>
                {hasLoadingError ? <h4>Error Loading Report</h4> :
                !hasLoadedData ? null :
                isLoadingData ? <LoaderAnimation /> :
                    <Box ref={report}>
                        {hwStatements.map(statementDetails => 
                            <HWStatementDetail
                                statementDetails={statementDetails}
                                statementDisclaimers={hwStatements[0].statementDisclaimers} />
                        )}
                    </Box>
                }
            </Box>
        </Box>
    )
}
